<template>
	<modal class="customize-columns-modal" size="large" @close="close">
		<template slot="header">
			<div class="flex-center">
				<i class="material-icons">view_week</i>
				<h3>Customize Columns</h3>
			</div>
		</template>
		<div slot="body">
			<div class="mb-3">
				<input type="text" class="form-control" placeholder="Search Column.." v-model="columnFilter" />
			</div>
			<div class="order-columns-category" v-for="(columns, category) in categorizedColumns" :key="category">
				<div class="order-columns-category-label">{{ category }}</div>
				<div class="row">
					<template v-for="(column, index) in columns">
						<div class="order-columns col-sm-4" :class="{ hidden: column.adminOnly && !isAdmin }"
							:key="index" v-if="column.label
								.toLowerCase()
								.indexOf(columnFilter.toLowerCase()) !== -1
								">
							<div class="form-group mb-1">
								<label>
									<input type="checkbox" class="input-checkbox input-checkbox-large" :value="column.value"
										v-model="modalSelectedColumns" />
									<span></span>
									<span class="input-checkbox-text">{{
										column.label
									}}</span>
									<i class="material-icons info mt-1" v-tooltip="column.info"
										v-if="column.info && column.info !== ''">
										info
									</i>
								</label>
							</div>
						</div>
					</template>
				</div>
			</div>
		</div>
		<div slot="footer">
			<button class="btn btn-light" @click="resetColumns">Cancel</button>
			<button class="btn btn-primary" :class="{ 'is-loading': isSavingColumns }" @click="applyColumns">
				Apply
			</button>
		</div>
	</modal>
</template>

<script>
import Modal from '@/components/Modal.vue';
import {
	duplicateVar,
} from '@/lib/helper';

export default {
	name: 'ModalCustomizeColumns',
	components: {
		Modal,
	},
	props: {
		categorizedColumns: {
			type: Object,
		},
		isAdmin: {
			type: Boolean,
		},
		isSavingColumns: {
			type: Boolean,
		},
		selectedColumns: {
			type: Array,
		},
	},
	data() {
		return {
			modalSelectedColumns: [],
			columnFilter: '',
		};
	},
	methods: {
		close() {
			this.$emit('close');
		},
		resetColumns() {
			this.$emit('reset-columns');
		},
		applyColumns() {
			this.$emit('apply-columns', this.modalSelectedColumns);
		},
	},
	watch: {
		selectedColumns(value) {
			this.modalSelectedColumns = duplicateVar(value);
		},
	},
	mounted() {
		this.modalSelectedColumns = duplicateVar(this.selectedColumns);
	},
};
</script>
